const menuItems = [
  {
    key: "nosotros",
    label: "Sobre nosotros",
    static: true,
    elemens: [
      { key: "st/nuestra-empresa", label: "Nuestra empresa", last: false },
      { key: "st/unidades-moviles", label: "Unidades móviles", last: false },
      { key: "st/centrales-comunicacion", label: "Central de comunicación", last: true },
    ]
  },
  { key: "st/productos", label: "Productos", static: false },
  {
    key: "info",
    label: "Información útil",
    static: true,
    elemens: [
      { key: "st/telefonos-utiles", label: "Teléfonos útiles", last: false },
      { key: "sucursales", label: "Sucursales", last: false },
      { key: "notas", label: "Notas y novedades", last: false },
      { key: "st/emergencias", label: "Qué hacer en una emergencia", last: false },
      { key: "st/formas-de-pago", label: "Formas de pago", last: false },
      { key: "st/como-leer-tu-factura", label: "¿Cómo leer tu factura?", last: true },
    ]
  },
  { key: "productos/consulta", label: "Quiero Asociarme", static: false },
];

export default menuItems;
